import * as firebase from "firebase/app";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

export const logEventStub = (name: string, payload?: object) => {
  console.log(name + ": " + JSON.stringify(payload));
};

export const logEvent = (name: string, payload?: object) => {
  console.log(name + ": " + JSON.stringify(payload));
  firebase.analytics().logEvent(name, payload);
};

export const FirebasePageAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    const pagePath = location.pathname + location.search;
    firebase.analytics().setCurrentScreen(pagePath);
    firebase.analytics().logEvent("page_view", { path: pagePath });
  }, [location]);

  return null;
};



// WEBPACK FOOTER //
// ./src/utils/Analytics.ts